/**
 * Central content config for ptemax.com.
 * Every marketing claim, price, and external URL lives here so copy can be
 * reviewed and changed without touching page code.
 * See CONTENT-TODO.md for items that need confirmation before launch.
 */

export const SITE_URL = "https://ptemax.com";
export const APP_URL = "https://app.ptemax.com";

export const links = {
  dashboard:`/admin/dashboard`,
  freeMock:`/free-pte-mock-test`,
  // freeMock: `${APP_URL}/register?src=mock-test`,
  // signIn: `${SITE_URL}/login`,
  signIn:`/auth/login`,
  contact:`/contact`,
  buy: (tier) => `${APP_URL}/register?src=pricing&plan=${tier}`,
  // TODO: replace with real demo-booking flow (Calendly / form endpoint)
  instituteDemo: "mailto:institutes@ptemax.com?subject=Demo%20request",
};

/**
 * Pricing — three outcome-named tiers by how long you have until your exam.
 * Prices are PPP-anchored per market (NOT raw FX), ending in locally-resonant
 * numbers. TODO: Varun to confirm every price point; the currency shown on the
 * page auto-detects at checkout. See CONTENT-TODO.md.
 */
export const tiers = [
  {
    id: "booster",
    name: "Booster",
    tagline: "A final sharpening",
    days: 14,
    for: "Exam in a week or two",
    highlighted: false,
    features: [
      "Unlimited practice on every task type",
      "Calibrated AI scoring with confidence bands",
      "Full-length & sectional mock tests",
      "Your weakest tasks, flagged",
    ],
  },
  {
    id: "target",
    name: "Target Score",
    tagline: "The full prep cycle",
    days: 60,
    for: "Exam in about a month",
    highlighted: true,
    features: [
      "Everything in Booster",
      "Sentence-level speaking feedback",
      "Templates & strategy for every task",
      "A study plan built around your exam date",
    ],
  },
  {
    id: "exam-ready",
    name: "Exam Ready",
    tagline: "No deadline pressure",
    days: 120,
    for: "Starting early, or re-sitting",
    highlighted: false,
    features: [
      "Everything in Target Score",
      "Four months of full access",
      "Re-plan as many times as you need",
      "Best value per day of prep",
    ],
  },
];

/** PPP-anchored price points per currency, in tier order (Booster / Target /
 *  Exam Ready). Confirm all before launch. */
export const pricing = {
  AUD: { symbol: "A$", label: "Australia", prices: [29, 89, 139] },
  USD: { symbol: "US$", label: "USD", prices: [9, 29, 49] },
  INR: { symbol: "₹", label: "India", prices: [599, 1999, 3499] },
  NPR: { symbol: "रू", label: "Nepal", prices: [999, 2999, 4999] },
  PHP: { symbol: "₱", label: "Philippines", prices: [499, 1499, 2499] },
};

/**
 * Task types shown on marketing pages, grouped by skill.
 * Names must match the real exam — verify against current Pearson format
 * before adding anything (Academic and Core differ per task).
 */
export const skills = [
  {
    name: "Speaking",
    tasks: ["Read Aloud", "Repeat Sentence", "Describe Image", "Answer Short Question"],
  },
  {
    name: "Writing",
    tasks: ["Summarize Written Text", "Write Essay"],
  },
  {
    name: "Reading",
    tasks: ["Reading & Writing: Fill in the Blanks", "Re-order Paragraphs", "Multiple Choice"],
  },
  {
    name: "Listening",
    tasks: ["Summarize Spoken Text", "Write From Dictation", "Highlight Incorrect Words"],
  },
];

/**
 * Launch trust stat. MUST be a real, defensible number before go-live.
 * "learners" = confirmed active users across the platform (incl. migrating
 * institute students). Confirm the true figure with Varun; don't inflate.
 */
export const trustStat = { value: "200+", label: "learners preparing with us" };

/**
 * Testimonials are intentionally NOT shipped. The homepage uses a
 * verifiable-proof block instead. When you have genuine, consented,
 * attributable quotes from real users, add a `testimonials` array here and a
 * section to render them — never invented ones (prohibited under ACCC / ASCI /
 * FTC consumer law). See CONTENT-TODO.md.
 */

export const disclaimer =
  "PTEMax is an independent test-preparation platform. It is not affiliated with, endorsed by, or sponsored by Pearson. PTE is a trademark of Pearson Education Ltd, used here only to identify the test we prepare students for.";
